<template>
  <div @contextmenu.prevent="handler($event)"
       :id="this.id"
       class="sitebuilder-element-container card big-is-receiver video-gallery-app-video"
       element="VideoGalleryComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :style="style()"
       :key="componentKey"
       v-on:click="focusElement($event)">

    <options-element-bar ref="optionsBar" :elem="this" name='ct-component-VideoGalleryComponent'></options-element-bar>

    <div class=" row-gallery" v-bind:style="{
      border:border,
      background: background,
      borderRadius: radius,
    }">

      <div class="col-gallery" v-bind:style="{width:width}">
        <!--          v-if="this.$props.preview"-->
        <iframe
          src=""
          :data-src="srcVideo"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="embed-responsive-item video-margin"
          loading="lazy"
        ></iframe>
        <!--        <div v-else class="embed-responsive-item video-margin" style="max-width: 300px">-->
        <!--          <img :src="thumbnail">-->
        <!--        </div>-->
      </div>

      <div class="sitebuilder-element-receiver col-gallery" v-bind:style="{width:widthPlace}">
        <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                   :id="element.id" :height_start="index" :preview="preview" :childs="element.childs"
                   @setCallbackChangeDevice="setCallbackChangeDevice"></component>
      </div>

      <i @click="closeThis" :class="'mdi close-icon ' + internal_config.icon"
         v-bind:style="{fontSize: fontSize, color: color}"></i>
    </div>
    <resources ref="resourcesData"></resources>

  </div>
</template>

<script>

  import Data from './Model';
  import Resources from './Resources.vue';
  import OptionsElementBar from "../../OptionsElementBar";

  export default {
    name: 'VideoGalleryComponent',
    props: ['config', 'childs', 'height_start', 'device', 'id', 'preview', 'url'],
    components: {
      OptionsElementBar,
      Resources
    },
    computed: {
      border() {
        return this.internal_config.border;
      },
      width() {
        return this.internal_config.width;
      },
      widthPlace() {
        return (100 - parseInt(this.internal_config.width)) + '%';
      },
      radius() {
        return this.internal_config.borderRadius;
      },
      fontSize() {
        return this.internal_config.fontSize;
      },
      color() {
        return this.internal_config.color;
      },
      background() {
        return this.internal_config.backgroundColor;
      },
      heightContainer() {
        return this.internal_config.heightContainer;
      },
      thumbnail() {
        return this.internal_config.videoData.thumbnail;
      },
      srcVideo() {

        try {
          let url = this.internal_config.videoData.url || '';

          if (typeof url !== undefined || url !== "") {
            if (url.indexOf('vidello') !== -1) {
              return url
            } else {
              let matchVimeo = url.match(/(videos|video|channels|\.com)\/([\d]+)/);
              if (matchVimeo) {
                return "https://player.vimeo.com/video/" + matchVimeo[2] + "?";
              } else {
                let matchWistia = url.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/(.*)/);
                if (matchWistia) {
                  return "https://fast.wistia.com/embed/medias/" + matchWistia[4];
                } else {
                  let match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/);
                  if (match && match[2].length == 11) {
                    return "https://www.youtube.com/embed/" + match[2] + "?";
                  } else {
                    return url;
                  }
                }
              }
            }
          }
        } catch (e) {

        }
      }
    },
    data() {
      return Data.data();
    }
    ,
    watch: {
      'internal_config':
        {
          deep: true,
          handler(value) {
            this.$eventHub.setValueElementConfig(this.id, value);
            this.$eventPointer.log(this.id, value);
          }
        }
      ,
    }
    ,
    created() {
      this.componentKey = '1';
    }
    ,
    methods: {
      animation() {
        return false;
      },
      changeOrderPanel(elem, idx) {

        let id = elem.$el.id,
          sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

        if (sibling === null) {
          return true;
        }

        this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);

      },

      focusElement(e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this);

        e.stopPropagation();
        e.preventDefault();
      },
      handler: function (e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this, true);

        e.stopPropagation();
        e.preventDefault();
      },
      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },
      style() {
        return `left:  ${this.internal_config.left};
                top: ${this.internal_config.top};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                z-index: ${this.internal_config.zIndex};
                margin: 0 auto;`;
      },
      showThis() {
        setTimeout(() => {
          $('#' + this.id).show();
        }, 500)
      },
      changeSideElements(colorValue) {
        let vm = this;
        setTimeout(() => {
          vm.$parent.$parent.setNewColor(colorValue);
        }, 500)
      },
      closeThis() {
        $(this.$el).hide();
        $('.container-gallery-video').hide();
        $("iframe").each(function () {
          let src = $(this).attr('src');
          $(this).attr('src', src);
        });
      },
      setCallbackChangeDevice(values) {
        this.$emit('setCallbackChangeDevice', values);
      },
      sendNewChilds() {

        let vm = this;

        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
          vm.$eventPointer.logChilds(vm.id, vm.elements);
          setTimeout(() => {
            vm.$eventPointer.changePointerState(true);
          }, 500)
        }, 1000)
      },
    },
    mounted() {

      let device, childs, id, config;
      ({device, childs, id, config} = this.$props);

      if (typeof config.backgroundColor === 'undefined') {
        config.backgroundColor = '#FFFFFF';
      }
      this.internal_config = config;
      this.device = device;

      if (typeof childs === 'undefined') {
        childs = [];
        this.internal_config.childs = [];
      }

      if (typeof id !== 'undefined') {
        this.id = id;
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });

      if (objIds.includes(this.id)) {
        let newId = Date.now() + parseInt(Math.random() * 10000);
        this.id = newId;

        childs.forEach((el, index) => {
          try {
            childs[index].config.parent_id = newId;
          } catch (e) {
          }
        });

        this.$refs.elem.id = newId;
      }

      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

      // this.internal_config = window.mergeRecursive(this.props, this.$props.config);
      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });

      this.$root.$on('setChildsObj', (id) => {
        if (this.id == id) {

          this.$eventPointer.logChilds(this.id, this.elements);

          let childsHub = this.$eventHub.getChilds(this.id);

          this.config.childs = childsHub;
          this.internal_config.childs = childsHub;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;

            this.$nextTick(() => {
              this.sendNewChilds();
              this.$root.$emit('activeSort');
              this.$refs.resourcesData.setValuesData(this);
            });
          });
        }
      });

      this.$root.$on('setChildsUndoRedo', (id, childs) => {
        if (this.id == id) {
          this.$eventHub.setChilds(this.id, childs);

          this.config.childs = childs;
          this.internal_config.childs = childs;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;
          });
        }
      });

      this.$root.$on('changeVideoColor', (id, colorValue) => {
        if (this.id == id) {
          this.config.backgroundColor = colorValue;
          this.internal_config.backgroundColor = colorValue;
        }
      })

      let videoData = this.$parent.$parent.getDataVideo(this.id);

      if (typeof videoData === 'undefined') {
        document.getElementById(this.id).parentNode.removeChild(document.getElementById(this.id));
      }

      this.internal_config.videoData = videoData;

      this.$refs.resourcesData.setValuesData(this);
    }
  }

</script>
<style lang="scss" scoped>

  .card-body {
    position: relative;
  }

  /*.sitebuilder-element-container.card {*/
  /*  height: auto !important;*/
  /*  width: 100% !important;*/
  /*  top: 0 !important;*/
  /*  left: 0 !important;*/
  /*  position: relative;*/
  /*  background-color: transparent !important;*/
  /*}*/

  [data-device="mobile"] .sitebuilder-element-receiver.card-body {
    height: auto !important;
  }

  .card-header {
    padding: 0 !important;
  }

  .row-gallery {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    top: 0;
    left: 0;

    .col-gallery {
      display: flex;
      flex-direction: column;
      width: 50%;
      height: 100% !important;
      position: relative;

      .video-margin {
        margin: auto;
        flex-grow: 1;
        border: none;
        padding: 0;
        max-height: 75%;
        max-width: 90%;
        width: 90%;
      }
    }
  }

  [data-device="mobile"],
  [data-device="tablet"] {
    .row-gallery {
      display: block;
    }

    .col-gallery {
      display: block;
      width: 100% !important;

      .embed-responsive-item {
        width: 100% !important;
        max-width: 100% !important;
      }
    }
  }

  [data-device="tablet"] {
    iframe.video-margin {
      height: 425px;
    }
  }

  .close-icon {
    position: absolute;
    right: 5px;
    top: 0;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/VideoGallery/Video/Video.vue